import React, { Component } from "react";
import { withConfigCatClient } from "configcat-react";

/**
 * Internal building block - injects `flags`/`configCatClient` props via the ConfigCat context,
 * re-reading every flag whenever the provider reports a config change.
 * Requires a provider (see ConfigCatProvider.js) somewhere above it in the tree.
 * Most widgets should use the composed `withFeatureFlags` from index.js instead.
 */
export default function withFlagsConsumer(WrappedComponent) {
    class FlagsConsumer extends Component {
        constructor(props) {
            super(props);
            this.state = { flags: {} };
        }

        componentDidMount() {
            this.loadFlags();
        }

        componentDidUpdate(prevProps) {
            const { lastUpdated } = this.props;
            if (prevProps.lastUpdated !== lastUpdated) {
                this.loadFlags();
            }
        }

        componentWillUnmount() {
            this.unmounted = true;
        }

        loadFlags() {
            const { configCatClient } = this.props;
            configCatClient.getAllValuesAsync().then((settings) => {
                if (!this.unmounted) {
                    this.setState({
                        flags: Object.fromEntries(settings.map(({ settingKey, settingValue }) => [settingKey, settingValue])),
                    });
                }
            });
        }

        render() {
            const { flags } = this.state;
            return <WrappedComponent {...this.props} flags={flags} />;
        }
    }

    return withConfigCatClient(FlagsConsumer);
}
